module.exports = __webpack_public_path__ + "img/calendar-plus-fill.e0957895.svg";